export default [
  // {
  //   path: '/auth',
  //   component: () => import(/* webpackChunkName: "loading" */ '@views/Loading.vue'),
  // },
];
